import React, { Suspense } from "react"
import { Company, User } from "../Menu/Menu"
import { useTokenData } from "../../hooks/useTokenData"
import { useUsersInfo } from "../../pages/contracts-view/hooks/useUsersInfo"
import { getInitials } from "../../utils/getInitials"
import { Loader } from "../Loader"

const EmptyPageLayout = ({ children }: { children: (user: User) => React.JSX.Element }) => {
  const { data } = useTokenData()
  const { data: userInfo, loading: loadingUserInfo } = useUsersInfo()

  if (!data || loadingUserInfo) return <Loader fullPage />

  const firstName = userInfo?.user.firstName || data.firstName
  const lastName = userInfo?.user.lastName || data.lastName
  const mobile = userInfo?.user.mobile ?? ""

  const userCompanies: Company = {
    vatCode: data.companyVatCode || "",
    name: data.companyName || "",
    active: true
  }

  const user: User = {
    name: firstName ?? "",
    initials: getInitials(`${firstName} ${lastName}`),
    fullName: `${firstName} ${lastName}`,
    companies: [userCompanies],
    email: data.email,
    mobile,
    data
  }

  return (
    <Suspense fallback={<Loader fullPage />}>
      <div>{children(user)}</div>
    </Suspense>
  )
}

export { EmptyPageLayout }
